import React, { forwardRef } from 'react';
import cn from 'classnames';
import "./FullSizeSkeleton.css";
var styles = { "skeleton": "bb48e5", "animation": "f3d234" };
const FullSizeSkeleton = forwardRef(({ isAnimationDisabled, className, testId }, ref) => (React.createElement("div", { className: cn(styles.skeleton, !isAnimationDisabled && styles.animation, className), "data-testid": testId, ref: ref })));
export default FullSizeSkeleton;
//# sourceMappingURL=FullSizeSkeleton.js.map